/**
 * Formats text by capitalizing first letter of each word and replacing underscores with spaces
 * @param {string} text - The text to format
 * @returns {string} - The formatted text
 */
export const formatText = text => {
  if (!text) return '-';

  // Replace underscores with spaces and split into words
  const words = text.split('_');

  // Capitalize first letter of each word and join with spaces
  return words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
};

/**
 * Formats a date string into a human-readable format
 * @param {string} dateString - The date string to format
 * @param {string} formatStr - Optional format string (default: 'MMM dd, yyyy')
 * @returns {string} - The formatted date
 */
export const formatDate = (dateString, formatStr = 'MMM dd, yyyy') => {
  if (!dateString) return '-';
  try {
    const { format } = require('date-fns');
    return format(new Date(dateString), formatStr);
  } catch (error) {
    return dateString;
  }
};

// Session fee a creative arts instructor picked at signup, stored in Koins.
// Shown in Riyals (1 Koin = 7.5 QR) with the Koins alongside.
export const formatCreativeFee = koins => {
  if (koins === null || koins === undefined || koins === '' || Number.isNaN(Number(koins))) {
    return '---';
  }
  const value = Number(koins);
  return `${(value * 7.5).toFixed(2)} Riyals (${value} Koins)`;
};
